import * as React from 'react';

import { Box, Button } from '@mui/material';

import { StepDefinition, StepId } from '../model/steps';

interface Props {
  steps: StepDefinition[];
  onReveal: (step: StepId) => void;
}

/** Footer hint while Submit is hidden: which sections still need input, each a link to it. */
const IncompleteSections: React.FC<Props> = ({ steps, onReveal }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      columnGap: 0.5,
    }}
  >
    To submit, complete:
    {steps.map((s) => (
      <Button key={s.id} size="small" onClick={() => onReveal(s.id)}>
        {s.label}
      </Button>
    ))}
  </Box>
);

export default IncompleteSections;
